import type { PropsWithChildren } from 'react'
import { Table, TableBody } from '@dhl-ui/components'

type Props = PropsWithChildren<{ 'data-testid'?: string }>

export const DataWrapper = ({ children, 'data-testid': dataTestId = 'data-wrapper' }: Props) => (
  <Table data-testid={dataTestId}>
    <TableBody>{children}</TableBody>
  </Table>
)
